import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const currentYear = new Date().getFullYear();
const TITLE = `Calculatrice TVA - Calculer la TVA avec précision`;
const DESCRIPTION =
  "Calculatrice TVA - Calculer la TVA avec précision. Outil financier en francais pour obtenir un calcul rapide, clair et exploitable pour vos decisions de budget, prix et rentabilite.";
const KEYWORDS =
  "tva tva précision, calculatrice financiere, budget, rentabilite, marge, gestion des couts, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/vat/";
function VATCalculator() {
  const [saleValue, setSaleValue] = useState("");
  const [vatRate, setVatRate] = useState("20");
  const [isSaleInclusiveOfVAT, setIsSaleInclusiveOfVAT] = useState("false");
  const [saleValueError, setSaleValueError] = useState("");
  const [vatRateError, setVatRateError] = useState("");
  const [vatResult, setVatResult] = useState("");
  const [totalValue, setTotalValue] = useState("");
  const [priceBeforeVat, setPriceBeforeVat] = useState("");

  const handleVatRateChange = (event) => {
    const inputVat = event.target.value;
    if (inputVat !== "") {
      const parsedVat = parseFloat(inputVat);
      if (!isNaN(parsedVat) && parsedVat >= 0 && parsedVat <= 100) {
        setVatRate(inputVat);
        setVatRateError("");
      } else {
        setVatRate(inputVat);
        if (isNaN(parsedVat)) {
          setVatRateError("Veuillez entrer un nombre valide");
        } else if (parsedVat < 0) {
          setVatRateError("La TVA ne peut pas être négative");
        } else if (parsedVat > 100) {
          setVatRateError("La TVA doit être entre 0 - 100%");
        }
      }
    } else {
      setVatRate("");
      setVatRateError("");
    }
  };

  const handleSaleChange = (event) => {
    const inputSale = event.target.value;
    if (inputSale !== "") {
      const parsedSale = parseFloat(inputSale);
      if (!isNaN(parsedSale) && parsedSale >= 0) {
        setSaleValue(inputSale);
        setSaleValueError("");
      } else {
        setSaleValue(inputSale);
        if (isNaN(parsedSale)) {
          setSaleValueError("Veuillez entrer un nombre valide");
        } else if (parsedSale < 0) {
          setSaleValueError("La valeur ne peut pas être négative");
        }
      }
    } else {
      setSaleValue("");
      setSaleValueError("");
    }
  };

  const handleReset = () => {
    setSaleValue("");
    setVatRate("20");
    setIsSaleInclusiveOfVAT("false");
    setSaleValueError("");
    setVatRateError("");
    setVatResult("");
    setTotalValue("");
    setPriceBeforeVat("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const sale = parseFloat(saleValue);
    const rate = parseFloat(vatRate);
    if (isNaN(sale) || isNaN(rate)) {
      return;
    }
    if (isSaleInclusiveOfVAT === "false") {
      const vatAmount = sale * (rate / 100);
      const total = sale + vatAmount;
      setVatResult(vatAmount.toFixed(2));
      setTotalValue(total.toFixed(2));
      setPriceBeforeVat(sale.toFixed(2));
    } else {
      const priceWithoutVat = sale / (1 + rate / 100);
      const vatAmount = sale - priceWithoutVat;
      setVatResult(vatAmount.toFixed(2));
      setTotalValue(sale.toFixed(2));
      setPriceBeforeVat(priceWithoutVat.toFixed(2));
    }
  };

  const generateSchemaData = () => {
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Accueil",
          item: "https://do-calculate.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Calculatrices Financières",
          item: "https://do-calculate.com/calculator/fr/financial/",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Calculatrice TVA",
          item: OG_URL,
        },
      ],
    };
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Qu'est-ce que la TVA?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "La TVA (Taxe sur la Valeur Ajoutée) est une taxe indirecte prélevée sur la consommation de biens et de services à chaque étape de la chaîne d'approvisionnement.",
          },
        },
      ],
    };
    return [breadcrumbSchema, faqSchema];
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "12px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>Calculatrice TVA</strong> est un outil gratuit et facile à utiliser pour 
                <strong> calculer la TVA</strong> avec précision. Vous pouvez <strong>ajouter la TVA</strong> à n'importe 
                quel montant ou <strong>l'extraire</strong> du montant total. Idéale pour les particuliers et les 
                entreprises pour calculer <strong>la TVA sur les ventes</strong> et <strong>la TVA sur les achats</strong> 
                dans n'importe quel pays avec différents taux de TVA.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-3 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "18px", margin: 0 }}>
                    Calculer la TVA
                  </h2>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3">
                    <label htmlFor="saleValue">
                      <strong>Montant de vente/achat:</strong>
                    </label>
                    <div className="d-flex align-items-center">
                      <input
                        id="saleValue"
                        type="number"
                        className="form-control"
                        value={saleValue}
                        onChange={handleSaleChange}
                        placeholder="Exemple: 1000"
                        step="0.01"
                        min="0"
                        required
                        style={{ maxWidth: "200px" }}
                      />
                    </div>
                    {saleValueError && (
                      <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                        {saleValueError}
                      </div>
                    )}
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="vatRate">
                      <strong>Taux TVA (%):</strong>
                    </label>
                    <div className="d-flex align-items-center">
                      <input
                        id="vatRate"
                        type="number"
                        className="form-control"
                        value={vatRate}
                        onChange={handleVatRateChange}
                        placeholder="Exemple: 15"
                        step="0.01"
                        min="0"
                        max="100"
                        required
                        style={{ maxWidth: "200px" }}
                      />
                      <span
                        style={{
                          marginLeft: "10px",
                          padding: "8px 15px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "#f9f9f9",
                          fontSize: "16px",
                        }}
                      >
                        %
                      </span>
                    </div>
                    {vatRateError && (
                      <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                        {vatRateError}
                      </div>
                    )}
                  </div>
                  <div className="form-group mb-4">
                    <label >
                      <strong>Le montant inclut-il la TVA?</strong>
                    </label>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                      <label style={{ cursor: "pointer", fontSize: "16px" }}>
                        <input
                          type="radio"
                          name="includeVat"
                          value="false"
                          checked={isSaleInclusiveOfVAT === "false"}
                          onChange={(e) => setIsSaleInclusiveOfVAT(e.target.value)}
                          style={{ marginRight: "8px" }}
                        />
                        Non (Ajouter la TVA)
                      </label>
                      <label style={{ cursor: "pointer", fontSize: "16px" }}>
                        <input
                          type="radio"
                          name="includeVat"
                          value="true"
                          checked={isSaleInclusiveOfVAT === "true"}
                          onChange={(e) => setIsSaleInclusiveOfVAT(e.target.value)}
                          style={{ marginRight: "8px" }}
                        />
                        Oui (Extraire la TVA)
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex gap-2">
                    <button
                      type="submit"
                      className="btn bg-success text-white"
                      style={{ fontSize: "16px", padding: "10px 30px" }}
                    >
                      Calculer
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleReset}
                      style={{ fontSize: "16px", padding: "10px 30px", marginLeft: "10px" }}
                    >
                      Réinitialiser
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-sm-12 col-md-4">
                {vatResult && totalValue && (
                  <div className="calculatorStyle">
                    <div className="p-3 mb-3 bg-success text-white text-center rounded">
                      <h3 style={{ fontSize: "18px", margin: 0 }}>Résultat</h3>
                    </div>
                    <div className="alert alert-success" style={{ fontSize: "16px" }}>
                      <table className="bmi-table" style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#e7f3fe",
                                padding: "12px",
                              }}
                            >
                              <strong>Montant avant TVA:</strong>
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#e7f3fe",
                                padding: "12px",
                              }}
                            >
                              <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                                {priceBeforeVat}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#fff3cd",
                                padding: "12px",
                              }}
                            >
                              <strong>Montant TVA ({vatRate}%):</strong>
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#fff3cd",
                                padding: "12px",
                              }}
                            >
                              <strong style={{ fontSize: "18px", color: "#856404" }}>
                                {vatResult}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#d1ecf1",
                                padding: "12px",
                              }}
                            >
                              <strong>Montant Total (TTC):</strong>
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#d1ecf1",
                                padding: "12px",
                              }}
                            >
                              <strong style={{ fontSize: "20px", color: "#0c5460" }}>
                                {totalValue}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div
              className="alert alert-info"
              style={{ fontSize: "15px", lineHeight: "1.8" }}
            >
              <strong>💡 Conseil:</strong> Cette <strong>calculatrice TVA</strong> supporte tous les taux de TVA 
              utilisés dans les pays européens et mondiaux. Vous pouvez calculer la TVA à 5%, 10%, 15%, ou tout 
              autre taux selon votre pays.
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {/* Contenu éducatif */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Qu'est-ce que la TVA ? Guide complet</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  La <strong>TVA (Taxe sur la Valeur Ajoutée)</strong> est une{" "}
                  <strong>taxe indirecte</strong> prélevée sur la consommation de
                  biens et services à chaque étape de la production et de la
                  distribution. Elle représente l'une des principales sources de
                  revenus des gouvernements dans plus de <strong>160 pays</strong>{" "}
                  dans le monde.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Comment fonctionne la TVA ?
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  La taxe est prélevée à chaque étape de la{" "}
                  <strong>chaîne d'approvisionnement</strong>:
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Fabricant :</strong> achète les matières premières en
                    payant la TVA, puis fabrique le produit et le vend en
                    ajoutant la TVA.
                  </li>
                  <li>
                    <strong>Grossiste :</strong> achète du fabricant en payant la
                    TVA, puis vend au détaillant en ajoutant la TVA.
                  </li>
                  <li>
                    <strong>Détaillant :</strong> achète du grossiste en payant
                    la TVA, puis vend au consommateur final en ajoutant la TVA.
                  </li>
                  <li>
                    <strong>Consommateur final :</strong> paie le prix complet
                    incluant la TVA.
                  </li>
                </ol>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 Exemple concret :</strong>
                  <br />
                  Un fabricant produit une chemise avec un coût de 50 €, la vend
                  à un commerçant pour 70 € + TVA 20% = 84 €.
                  <br />
                  Le commerçant la vend au consommateur pour 100 € + TVA 20% =
                  120 €.
                  <br />
                  <strong>TVA finale :</strong> 20 € payée par le consommateur.
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Caractéristiques de la TVA :
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Taxe indirecte :</strong> payée par le consommateur
                    mais collectée par les vendeurs
                  </li>
                  <li>
                    <strong>Prélevée sur la valeur ajoutée :</strong> uniquement
                    sur la différence entre le prix d'achat et de vente
                  </li>
                  <li>
                    <strong>Déductible :</strong> les entreprises récupèrent la
                    TVA qu'elles ont payée sur les achats
                  </li>
                  <li>
                    <strong>Transparent :</strong> clairement affiché sur les
                    factures
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>
                  Comment calculer la TVA ? Formules et exemples
                </strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Il existe deux façons de <strong>calculer la TVA</strong>:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  1. Ajouter la TVA au prix
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Utilisée lorsque le <strong>prix hors taxe</strong> est connu
                  et qu'on veut connaître le prix final:
                </p>
                <div
                  className="alert alert-success"
                  style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                >
                  <strong>Formule :</strong>
                  <br />
                  <code style={{ fontSize: "16px" }}>
                    Montant TVA = Prix × (taux TVA ÷ 100)
                    <br />
                    Prix Total = Prix + Montant TVA
                    <br />
                    ou : Prix Total = Prix × (1 + taux TVA ÷ 100)
                  </code>
                </div>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>Exemple :</strong>
                  <br />
                  Article coûtant 1000 €, TVA 20%
                  <br />
                  Montant TVA = 1000 × (20 ÷ 100) = <strong>200 €</strong>
                  <br />
                  Prix final = 1000 + 200 = <strong>1200 €</strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  2. Extraire la TVA du prix TTC
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Utilisée lorsque le <strong>prix TTC (toutes taxes incluses)</strong>{" "}
                  est connu et qu'on veut connaître le montant de TVA:
                </p>
                <div
                  className="alert alert-warning"
                  style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
                >
                  <strong>Formule :</strong>
                  <br />
                  <code style={{ fontSize: "16px" }}>
                    Prix HT = Prix TTC ÷ (1 + taux TVA ÷ 100)
                    <br />
                    Montant TVA = Prix TTC - Prix HT
                  </code>
                </div>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>Exemple :</strong>
                  <br />
                  Article coûtant 1200 € TTC avec TVA 20%
                  <br />
                  Prix HT = 1200 ÷ (1 + 20 ÷ 100) = 1200 ÷ 1,20 ={" "}
                  <strong>1000 €</strong>
                  <br />
                  Montant TVA = 1200 - 1000 = <strong>200 €</strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Formule rapide pour calculer la TVA :
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>TVA 5,5% :</strong> multiplier par 0,055 (ajout) ou
                    diviser par 19,2 (extraction)
                  </li>
                  <li>
                    <strong>TVA 10% :</strong> multiplier par 0,10 (ajout) ou
                    diviser par 11 (extraction)
                  </li>
                  <li>
                    <strong>TVA 20% :</strong> multiplier par 0,20 (ajout) ou
                    diviser par 6 (extraction)
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>TVA en France - Taux et application</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  En France, il existe plusieurs <strong>taux de TVA</strong>{" "}
                  appliqués selon le type de produit ou service:
                </p>
                <table className="bmi-table" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th className="bmi-header" style={{ textAlign: "center" }}>
                        Type de produit
                      </th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>
                        Taux
                      </th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>
                        Application
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>TVA normale</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          20%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        Plupart des biens et services
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>TVA réduite</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          5,5%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        Produits alimentaires, transports
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>TVA Très réduite</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          2,1%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        Journaux, médicaments
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>Taux zéro</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          0%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        Certaines exportations
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Qui doit facturer la TVA ? Obligations légales</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  En France, <strong>tous les commerçants</strong> ayant un chiffre
                  d'affaires supérieur à un certain seuil doivent facturer et
                  reverser la TVA:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Seuil général :</strong> 85 800 € de CA (année)
                  </li>
                  <li>
                    <strong>Seuil réduit :</strong> 34 400 € pour les services
                  </li>
                  <li>
                    <strong>Auto-entrepreneurs :</strong> généralement exemptés
                    de TVA (régime micro-social)
                  </li>
                  <li>
                    <strong>Entreprises :</strong> obligatoires pour celles
                    dépassant les seuils
                  </li>
                </ul>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Important :</strong> Même en dessous du seuil, vous
                  pouvez opter pour le versement volontaire de la TVA si vous
                  prévoyez une croissance rapide.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>TVA déductible - Comment récupérer votre TVA</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Les entreprises peuvent <strong>déduire la TVA</strong> qu'elles
                  ont payée sur leurs achats professionnels:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Ce qui est déductible :
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>TVA sur l'achat de matières premières</li>
                  <li>TVA sur les services professionnels</li>
                  <li>TVA sur l'achat d'équipements</li>
                  <li>TVA sur les fournitures de bureau</li>
                  <li>TVA sur le transport professionnel</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Ce qui n'est pas déductible :
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>TVA sur les dépenses personnelles</li>
                  <li>
                    TVA sur les services qui ne sont pas professionnels
                  </li>
                  <li>TVA sur les voitures particulières (sauf cas spécifiques)</li>
                  <li>TVA sur les repas et hébergement (partiellement)</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Astuces pour bien gérer votre TVA</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Voici quelques <strong>conseils pratiques</strong> pour bien
                  gérer votre TVA:
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Gardez toutes vos factures :</strong> Conservez les
                    preuves de vos achats pour justifier les déductions
                  </li>
                  <li>
                    <strong>Facturation régulière :</strong> Envoyez des factures
                    détaillées incluant la TVA
                  </li>
                  <li>
                    <strong>Déclarations à temps :</strong> Faites vos
                    déclarations de TVA aux délais impartis
                  </li>
                  <li>
                    <strong>Registre de ventes :</strong> Tenez à jour un registre
                    de toutes vos ventes
                  </li>
                  <li>
                    <strong>Registre d'achats :</strong> Documentez tous vos
                    achats professionnels
                  </li>
                  <li>
                    <strong>Logiciel comptable :</strong> Utilisez un outil de
                    gestion pour éviter les erreurs
                  </li>
                  <li>
                    <strong>Conseil d'expert :</strong> Consultez un expert
                    comptable pour les cas complexes
                  </li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>
                  Erreurs courantes en TVA à éviter absolument
                </strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Voici les <strong>erreurs les plus fréquentes</strong> que les
                  entrepreneurs commettent:
                </p>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <strong>❌ Erreur 1 :</strong> Ne pas facturer la TVA quand
                  c'est obligatoire
                  <br />
                  <strong>Conséquence :</strong> Pénalités et intérêts de retard
                </div>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <strong>❌ Erreur 2 :</strong> Déduire la TVA sur des achats
                  personnels
                  <br />
                  <strong>Conséquence :</strong> Contrôle fiscal et redressement
                </div>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <strong>❌ Erreur 3 :</strong> Appliquer le mauvais taux de TVA
                  <br />
                  <strong>Conséquence :</strong> Correction de vos déclarations
                  et pénalités
                </div>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <strong>❌ Erreur 4 :</strong> Mal conserver les factures
                  <br />
                  <strong>Conséquence :</strong> Impossibilité de justifier vos
                  déductions
                </div>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <strong>❌ Erreur 5 :</strong> Déclarer en retard
                  <br />
                  <strong>Conséquence :</strong> Pénalités et intérêts
                  supplémentaires
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default VATCalculator;
